import { Button, Modal, Spin } from "antd";
import { lazy, Suspense, useEffect, useState } from "react";
import "./style.css";

const FirebaseAuthUI = lazy(() => import("@/components/FirebaseAuthUI"));

function SignupPopup(props: { openOnLoad?: boolean }) {
    const { openOnLoad = false } = props;
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const [email, setEmail] = useState("");

    useEffect(() => {
        if (openOnLoad) {
            setShowPopup(true);
        }
    }, [openOnLoad]);

    const handleJoinClick = () => {
        setShowPopup(true);
    };
    const onClose = () => {
        setShowPopup(false);
    };

    return (
        <div>
            <div className="email-signup-form">
                <div className="email-text-box">
                    <input
                        type="email"
                        placeholder="email@address.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        style={{
                            padding: "10px 15px",
                            borderRadius: "5px",
                            border: "1px solid #ccc",
                            width: "250px",
                            fontSize: "14px",
                        }}
                    />
                    <Button onClick={handleJoinClick} className="take-me-to-trial-finder">
                        Join the Registry
                    </Button>

                    <Modal open={showPopup} footer={null} onCancel={onClose} centered width={720} destroyOnHidden>
                        <Suspense fallback={<Spin />}>
                            <FirebaseAuthUI email={email} mode="signUp" />
                        </Suspense>
                    </Modal>
                </div>
            </div>
        </div>
    );
}

export default SignupPopup;
